@if (blocked()) {
  <av-unsupported-device />
} @else {
  <av-global-loader />
  <av-impersonation-notch />
  <av-consent-lock-banner />
  <router-outlet />
}
